import {http} from '@/http'

export default {
  listDaily(params) {
    return http.get('api/v1/purchase/daily', {params})
  }
}
